import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.36 2.852a1.044 1.044 0 011.473-.09l4.303 3.812a1.044 1.044 0 01-.692 1.825H7.397a1.044 1.044 0 110-2.087h9.294L14.45 4.325a1.044 1.044 0 01-.09-1.473zM6.615 17.148a1.044 1.044 0 01-1.473.09L.839 13.426a1.044 1.044 0 01.692-1.825h12.046a1.044 1.044 0 010 2.087H4.283l2.243 1.987c.431.382.471 1.042.09 1.473z"
      clipRule="evenodd"
    />
  </Icon>
));
